// extracted by mini-css-extract-plugin
export default {"container":"ImageThumbnail_container__5PtED","overlay":"ImageThumbnail_overlay__hpD7T"};